module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/sola_footer_image_01-b5935ce8f8fa117849679bba18e69311.jpg";